import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  venue: string
  isOrderConfirmed: boolean
  hasBooking: boolean
  wasSomethingPayed: boolean
}

const ConfirmationHeading: React.FC<React.PropsWithChildren<Props>> = ({
  venue,
  isOrderConfirmed,
  hasBooking,
  wasSomethingPayed,
}) => {
  if (!hasBooking && !wasSomethingPayed) {
    return <Localized id="free-product-confirmation-heading" />
  }

  if (!hasBooking) {
    return <Localized id="booking-payment-confirmation-heading" />
  }

  if (isOrderConfirmed) {
    return <Localized id="booking-confirmation-heading" />
  }

  return <Localized id="booking-confirmation-heading-not-confirmed" params={{ venue }} />
}

export default ConfirmationHeading
